import { useEffect } from "react";
import { atom, useSetRecoilState } from "recoil";

export const Me = atom({
  key: "Me",
  default: null,
});

export function MeApi() {
  const setMe = useSetRecoilState(Me);

  useEffect(() => {
    getMe().then((result) => setMe(result));
  }, [setMe]);
}

async function getMe() {
  const response = await fetch("/me");

  if (response.ok) {
    const data = await response.json();

    return data.clientPrincipal;
  }
}
